/* NINEPADEL theme JS — countdown, stat bars, qty, mega menu touch support */
(function () {
  'use strict';

  /* Delivery countdown — counts down to the section's cutoff hour (store local time
     approximated by the shopper's clock), shows next valid delivery day */
  function initCountdown() {
    document.querySelectorAll('[data-np-countdown]').forEach(function (el) {
      var cutoffHour = parseInt(el.dataset.cutoffHour || '15', 10);
      var target = el.querySelector('[data-np-count]');
      var dayEl = el.querySelector('[data-np-delivery-day]');
      if (!target) return;

      function nextCutoff() {
        var now = new Date();
        var cutoff = new Date(now);
        cutoff.setHours(cutoffHour, 0, 0, 0);
        // if past cutoff, or it's Sat/Sun (no dispatch), roll to next weekday cutoff
        while (cutoff <= now || cutoff.getDay() === 0 || cutoff.getDay() === 6) {
          cutoff.setDate(cutoff.getDate() + 1);
          cutoff.setHours(cutoffHour, 0, 0, 0);
        }
        return cutoff;
      }

      function deliveryDayAfter(cutoff) {
        var d = new Date(cutoff);
        d.setDate(d.getDate() + 1);
        while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
        return d;
      }

      var cutoff = nextCutoff();
      if (dayEl) {
        var d = deliveryDayAfter(cutoff);
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var suffix = ['th', 'st', 'nd', 'rd'][((d.getDate() % 100) - 20) % 10] || ['th', 'st', 'nd', 'rd'][d.getDate() % 100] || 'th';
        dayEl.textContent = days[d.getDay()] + ' ' + d.getDate() + suffix + ' ' + months[d.getMonth()];
      }

      function tick() {
        var secs = Math.max(0, Math.floor((cutoff - new Date()) / 1000));
        var h = String(Math.floor(secs / 3600)).padStart(2, '0');
        var m = String(Math.floor((secs % 3600) / 60)).padStart(2, '0');
        var s = String(secs % 60).padStart(2, '0');
        target.textContent = h + ':' + m + ':' + s;
        if (secs === 0) cutoff = nextCutoff();
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* Stat bars animate in on scroll */
  function initBars() {
    var section = document.querySelector('[data-np-nineread]');
    if (!section) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.np-fill').forEach(function (f) {
            f.style.width = f.dataset.w;
          });
          io.disconnect();
        }
      });
    }, { threshold: 0.3 });
    io.observe(section);
  }

  /* Quantity +/- */
  function initQty() {
    document.querySelectorAll('.np-qty').forEach(function (q) {
      var input = q.querySelector('input');
      q.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn || !input) return;
        e.preventDefault();
        var v = parseInt(input.value || '1', 10);
        input.value = Math.max(1, v + (btn.dataset.dir === 'up' ? 1 : -1));
      });
    });
  }

  /* Product gallery thumbnails */
  function initGallery() {
    var stage = document.querySelector('[data-np-stage-img]');
    if (!stage) return;
    document.querySelectorAll('[data-np-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        stage.src = btn.dataset.npThumb;
        if (btn.dataset.npThumbSrcset) stage.srcset = btn.dataset.npThumbSrcset; else stage.removeAttribute('srcset');
        document.querySelectorAll('[data-np-thumb]').forEach(function (b) { b.classList.remove('np-on'); });
        btn.classList.add('np-on');
      });
    });
  }

  /* Mega menu: open on tap for touch devices (hover handles desktop) */
  function initMega() {
    document.querySelectorAll('.np-navitem').forEach(function (item) {
      var link = item.querySelector(':scope > a');
      var mega = item.querySelector('.np-mega');
      if (!link || !mega) return;
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches || e.detail === 0) {
          e.preventDefault();
          item.classList.toggle('np-open');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.np-navitem')) {
        document.querySelectorAll('.np-navitem.np-open').forEach(function (i) { i.classList.remove('np-open'); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCountdown(); initBars(); initQty(); initGallery(); initMega();
    });
  } else {
    initCountdown(); initBars(); initQty(); initGallery(); initMega();
  }
})();
